import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/datePicker/constants';
import Button from '../button/index';
import { noop } from '@douyinfe/semi-foundation/lib/es/utils/function';
const prefixCls = cssClasses.PREFIX;

class QuickControl extends PureComponent {
  render() {
    var _context;

    const {
      presets,
      onPresetClick,
      type
    } = this.props;
    const wrapperCls = classNames("".concat(prefixCls, "-quick-control"), {
      [_concatInstanceProperty(_context = "".concat(prefixCls, "-quick-control-")).call(_context, type)]: type
    });
    const itemCls = classNames("".concat(prefixCls, "-quick-control-item"));

    if (!presets.length) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: wrapperCls
    }, _mapInstanceProperty(presets).call(presets, (item, index) => {
      const _item = typeof item === 'function' ? item() : item;

      return /*#__PURE__*/React.createElement("div", {
        className: itemCls,
        onClick: e => onPresetClick(_item, e),
        key: index
      }, /*#__PURE__*/React.createElement(Button, {
        size: "small",
        theme: "borderless",
        type: "primary"
      }, /*#__PURE__*/React.createElement("span", null, _item.text)));
    }));
  }

}

QuickControl.propTypes = {
  presets: PropTypes.array,
  onPresetClick: PropTypes.func,
  type: PropTypes.string
};
QuickControl.defaultProps = {
  presets: [],
  onPresetClick: noop
};
export default QuickControl;